import maDatePicker from 'v-calendar/lib/components/date-picker.umd'

/**
 * @module
 * @name datePicker
 */
export default {
  name: 'datePicker',
  props: {
    literal: {
      required: true,
      type: String
    },
    errorInput: {
      required: false,
      type: Boolean
    },
    handleChangeInput: {
      required: true,
      type: Function
    }
  },

  /**
   * @property {Object} dateMask data picker property - the date format of the input value as a mask
   * @property {Object} datePopover data picker property - sets the way the calendar appears
   * @property {String} minDate data picker property - the minimum date it can be selected
   * @property {String} value data picker property - value of the input, not needed as it is passed by the handleChangeInput action by props
   * @property {String} datePickerProps data picker property - holds the props as class and placeholder
   * @property {Object} theme data picker property - holds the sytle related props as the container liht theme class or color of the dot of the calendar
   */
  data: function () {
    return {
      dateMask: {
        input: ['DD/MM/YYYY']
      },
      datePopover: {
        'visibility': 'click'
      },
      minDate: null,
      value: '',
      datePickerProps: {
        'class': 'datePicker-input',
        'placeholder': 'JJ/MM/AAAA'
      },
      theme: {
        container: {
          light: 'popover-calendar'
        },
        color: 'blue'
      }

    }
  },
  components: {
    maDatePicker
  },

  methods: {
  /**
   * @function
   * @name setMinDate
   * @descrription Sets the minimum date - 20years before the current date
   */
    setMinDate () {
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth()
      const day = today.getDate()
      this.minDate = new Date(year - 20, month, day)
    }
  },

  /**
   * @function
   * @name mounted
   * @descrription Executes the setMinDate method
   */
  mounted () {
    this.setMinDate()
  }

}
